import { BoxConfig } from '../../stage';

export interface MenuShelfOptionsProps {
	readonly addShelf: (config: BoxConfig) => void;
}

export const MenuShelfOptions = (props: MenuShelfOptionsProps) => {
	return (
			<div className="grid grid-cols-2 gap-2 p-4 border-b border-gray-200">
				<button type="button"
				        className="add-cube w-full inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 opacity-50 pointer-events-none"
				        onClick={() => props.addShelf({ size: 'small' })}>Add Small Shelf
				</button>
				<button type="button"
				        className="add-cube w-full inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 opacity-50 pointer-events-none"
				        onClick={() => props.addShelf({ size: 'wide' })}>Add Wide Shelf
				</button>
				<button type="button"
				        className="add-cube add-cube__tall w-full inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 opacity-50 pointer-events-none"
				        onClick={() => props.addShelf({ size: 'tall' })}>Add Tall Shelf
				</button>
				<button type="button"
				        className="add-cube w-full inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 opacity-50 pointer-events-none"
				        onClick={() => props.addShelf({ size: 'large' })}>Add Large Shelf
				</button>
				<button type="button"
				        className="add-cube add-cube__small-corner w-full inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 opacity-50 pointer-events-none"
				        onClick={() => props.addShelf({ size: 'small-corner' })}>Add Small Corner
				</button>
				<button type="button"
				        className="add-cube add-cube__tall-corner w-full inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 opacity-50 pointer-events-none"
				        onClick={() => props.addShelf({ size: 'tall-corner' })}>Add Tall Corner
				</button>
			</div>
	);
};
